export const USER_MASTER_TABLEDATA = 'USER_MASTER_TABLEDATA'
export const BRANCH_DETAILS = 'BRANCH_DETAILS'
export const UPDATE_MODAL_HEADER_DROPOWN = 'UPDATE_MODAL_HEADER_DROPOWN'
export const USERROLLRIGHT_TABLEDATA = 'USERROLLRIGHT_TABLEDATA'
export const AUTO_DEACTIVATE_USER_TBLDATA = 'AUTO_DEACTIVATE_USER_TBLDATA'
export const ADU_CATEGORY_DATA = 'ADU_CATEGORY_DATA'
export const MAC_REQUESTS_TABLE_DATA = 'MAC_REQUESTS_TABLE_DATA'
export const BRANCH_LIST_CONFIG = 'BRANCH_LIST_CONFIG'
export const MAC_AUTH_TABLE_DATA = 'MAC_AUTH_TABLE_DATA'
export const MAVEN_MGMT_TABLE_DATA = 'MAVEN_MGMT_TABLE_DATA'
export const MAC_MGMT_TABLE_DATA = 'MAC_MGMT_TABLE_DATA'
export const BRANCH_MAC_DETAILS = 'BRANCH_MAC_DETAILS'
export const BRANCH_COMMISSION_FOR_ALL = 'BRANCH_COMMISSION_FOR_ALL'
